const toggleOOSItems = (e) => {
  const toggleButton = document.querySelector(
    '.thb-filter-availability input[name="filter.v.availability"]'
  );
  if (toggleButton) {
    toggleButton.click();
  }
};

setInterval(() => {
  const url = new URLSearchParams(window.location.search);
  if (url.has("filter.v.availability")) {
    document.getElementById("hideOOS").checked = true;
  }

  const facetRemove = document.querySelector("facet-remove");
  if (facetRemove) {
    const facetCount = facetRemove.children.length;
    const firstChildIsInStock =
      facetRemove.children[0]?.textContent.trim().toLowerCase() ===
        "in stock" || false;

    if (facetCount === 2 && firstChildIsInStock) {
      facetRemove.style.display = "none";
    } else {
      facetRemove.style.display = "";

      if (firstChildIsInStock) {
        facetRemove.children[0].style.display = "none";
      }
    }
  }
}, 1000);

document.addEventListener('DOMContentLoaded', () => {
  
  function addProductToCart(variantId, store, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      if (callback) callback(store); 
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function updateCartAttributes(store) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Selected Store': store
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attributes updated:', data);
    
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 1000); 
    })
    .catch(error => {
      console.error('Error updating cart attributes:', error);
    });
  }
   function showPopup(message) {
    const popup = document.getElementById('popup-modal');
    const popupMessage = document.getElementById('popup-message');
    popupMessage.textContent = message;
    popup.style.display = 'block';
  }

  function hidePopup() {
    const popup = document.getElementById('popup-modal');
    popup.style.display = 'none';
  }

  // Function to handle the proceed button click
  function handleProceedButtonClick(button) {
    const selectedStore = document.querySelector('input[name="select_store_location"]:checked').value;
    console.log("selectedStore", selectedStore);
    const variantId = button.getAttribute('data-id'); // Use the passed element

    console.log("variantId", variantId);

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          addProductToCart(variantId, selectedStore, updateCartAttributes);
        } else {
          showPopup('Only one product is allowed in the cart. Please remove the existing product before adding a new one.');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
}

  // // Initial setup
  // setTimeout(function() {
  //   const proceedpickupButton = document.getElementById('proceed-pickup');

  //   if (proceedpickupButton) {
  //     console.log('clicked');
  //     proceedpickupButton.addEventListener('click', handleProceedButtonClick);
  //   }
  // }, 3000);

  $(document).on('click', '#proceed-pickup', function(event) {
    event.preventDefault();
    handleProceedButtonClick(this);
  });

   const popupClose = document.getElementById('popup-close');
  const popupOk = document.getElementById('popup-ok');

  if (popupClose) {
    popupClose.addEventListener('click', hidePopup);
  }

  if (popupOk) {
    popupOk.addEventListener('click', hidePopup);
  }

});
